import MuiMenuItem from "@mui/material/MenuItem";
const MenuItem = MuiMenuItem;
export default MenuItem;
